

export const MenuData = [
    {
        title: 'Home',
        path: '/',
        className: 'menu-item'
    },
    {
        title: 'Portfolio',
        path: '/portfolio',
        className: 'menu-item'
    },
    // {
    //     title: 'Contacto',
    //     path: '/contact',
    //     className: 'menu-item'
    // },
    {
        title: 'Sobre mi',
        path: '/about',
        className: 'menu-item'
    }
]


export let cPanelMenu = [

    {
        id: 1,
        link: '/controlpanel/inicio',
        name: 'INICIO'
    },
    {
        id: 2,
        link: '/controlpanel/proyectos',
        name: 'PROYECTOS'

    },
    {
        id: 3,
        link: '/controlpanel/precios',
        name: 'PRECIOS'
    },
    {
        id: 4,
        link: '/controlpanel/homeskills',
        name: 'SKILLS'
    }

]

export let menuCategorias =  [
    {
        id:1,
        nombre: 'PROYECTOS',
        to:'/controlpanel/proyectos'
    },
    {
        id:2,
        nombre: 'PRECIOS',
        to:'/controlpanel/precios'
    },
    {
        id:3,
        nombre: 'SKILLS',
        to:'/controlpanel/homeskills'
    }
]